import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { AccessibleTreeView } from '@bingads-webui-react/accessible-tree-view';
import { NodeProps } from '@bingads-webui-react/tree-view';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { TreeNodeRenderer } from './tree-node-renderer';
import BackMenuItem from './back-menu-item';
import { getNavigationBarTreeStyles } from '../../../styles/navigation-bar-tree-styles';

class NavigationBarTree extends React.PureComponent {
  componentDidUpdate() {
    if (this.props.perfMarker &&
      !this.props.perfMarker.isDone
    ) {
      this.props.perfMarker.done();
    }
  }

  // Not show expand icon. Click node itself to expand/collaps.
  getTreeIconsClassNameMap = classes => ({
    expanded: classes.expandIconHidden,
    collapsed: classes.expandIconHidden,
    running: classes.expandIconHidden,
  });

  render() {
    const { classes, scrollToId } = this.props;

    return (
      <React.Fragment>
        {
          this.props.showBackMenuItem
            && <BackMenuItem
              backText={this.props.backMenuItemText}
              onBackClicked={this.props.onBackClicked}
            />
        }
        <AccessibleTreeView
          ariaLabel={this.props.ariaLabel}
          nodes={this.props.treeNodes}
          treeViewClassNames={classNames(classes.treeViewContainer, 'main-menu-tree')}
          iconsClassNameMap={this.getTreeIconsClassNameMap(classes)}
          nodeRenderer={TreeNodeRenderer()}
          nodeChildRenderer={this.props.nodeChildRenderer(classes)}
          updateTypeHandlers={this.props.updateTypeHandlers}
          scrollToId={scrollToId}
          nodePaddingLeft={0}
          // onChange property is required by TreeView, however we don't need
          // it as we do our staff within updateTypeHandlers.
          onChange={() => {}}
          shouldClearCellMeasurerCache={this.props.shouldClearCellMeasurerCache}
        />
      </React.Fragment>
    );
  }
}

NavigationBarTree.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getNavigationBarTreeStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  treeNodes: PropTypes.arrayOf(NodeProps).isRequired,
  updateTypeHandlers: PropTypes.objectOf(PropTypes.func).isRequired,
  nodeChildRenderer: PropTypes.func.isRequired,
  showBackMenuItem: PropTypes.bool,
  backMenuItemText: PropTypes.string,
  onBackClicked: PropTypes.func.isRequired,
  scrollToId: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    PropTypes.string.isRequired,
  ]),
  perfMarker: PropTypes.shape({
    done: PropTypes.func.isRequired,
    isDone: PropTypes.bool.isRequired,
  }),
  ariaLabel: PropTypes.string,
  shouldClearCellMeasurerCache: PropTypes.bool,
};

NavigationBarTree.defaultProps = {
  showBackMenuItem: false,
  backMenuItemText: '',
  scrollToId: null,
  perfMarker: null,
  ariaLabel: '',
  shouldClearCellMeasurerCache: false,
};

export default withDefaultStyles(NavigationBarTree, getNavigationBarTreeStyles);
